import { render, staticRenderFns } from "./BtnDistribuirAditivoContrato.vue?vue&type=template&id=86f5ab10"
import script from "./BtnDistribuirAditivoContrato.vue?vue&type=script&lang=js"
export * from "./BtnDistribuirAditivoContrato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports